<template>
  <div class="container-fluid" style="position: absolute; min-width: 100%; min-height: 100%; max-width: 100%; display: flex; align-items: center;"><!--bg-maintenance-image-->

    <QrCode ref="QrCode" :name="'QrCode'" @onQr="getQr" :serialME="false" :manual="true"/>

    <div class="col-md-6 offset-md-3 col-xs-12 pt-1">
      
      <div class="card border-grey border-lighten-3 box-shadow-3">
        
        <div class="card-block text-xs-center" style="z-index: 6; position: relative">
          <span class="card-title text-xs-center">
            <a @click="openURL('https://modern-expo.eu')"><img src="../assets/pictures/me_logo.png" class="img-fluid mx-auto d-block pt-2" width="250" alt="logo"></a>
          </span>
        </div>

        <div class="card-block" style="z-index: 6;  position: relative">
          
          <div class="row mb-1" v-if="changeTS || askPayment">
            <div class="d-flex justify-content-center">
              <h4 >Талон : {{number}}</h4>
            </div>
          </div>

          <div class="row mb-1">
            <div class="d-flex justify-content-center">
              <button v-if="scanQR" type="button" class="btn btn-lg btn-primary" @click="showModalQR()"  data-html="true" :title=" $t('equipm.hint.scanQr')">
                <i class="icon-qrcode"></i> Scan QR
              </button>
              <button v-if="changeTS" type="button" class="btn btn-lg" :class="'btn-' + classes" @click="changeTalon()">
                <i class="icon-loop22"></i> Підтвердження виїзду
              </button>
            </div>
          </div>

          <div class="row" v-if="showInfo && !askPayment">

            <div class="col-md-8 offset-md-2">
              <h5>До сплати</h5>
              <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" :value="amount" class="form-control form-control-lg input-lg" disabled>
                  <div class="form-control-position">
                      <i style="font-size: 1.8em;">₴</i>
                  </div>
              </fieldset>
            </div>

            <div class="col-md-8 offset-md-2">
              <h5>Дата виїзду</h5>
              <fieldset class="form-group position-relative has-icon-left">
                  <input type="text" v-model="date" :placeholder="$t('check.titles.passCard')" class="form-control form-control-lg input-lg" disabled>
                  <div class="form-control-position">
                      <i class="icon-clock3"></i>
                  </div>
              </fieldset>
            </div>

          </div>

          <div class="row" v-if="askPayment">
            <h4 class="form-section text-xs-center">Чи оплачено виїзд ?</h4>
            <div class="d-flex justify-content-center">
              <button type="button" class="btn btn-lg btn-success" @click="payment = true; changeTalon()">
                <i class="icon-checkmark2"></i> Так
              </button>
              <button type="button" class="btn btn-lg btn-danger ml-1" @click="clearParams()">
                <i class="icon-cross"></i> Ні
              </button>
            </div>
          </div>

          

        </div>

        
        

      </div>
    </div>
  </div>
       
</template>

<script>

  export default {
      name: "Parking",
      components: {},
      data() {
          return {
            guidTalon: null,// f41a2b6f-24f3-11ec-80ec-248a07729990
            allowed: null,
            classes: 'secondary',
            date: null,
            number: null,
            amount: null,

            payment: false,
            askPayment: false,

            scanQR: true,
            changeTS: false,
            showInfo: false,
          };
        },
        methods: {
          getQr(smth) {
            if ( this.isValid(smth) ){
              this.guidTalon = smth;
              this.sendQ();
            }
          },
          
          sendQ(){
            this.clearParams();

            this.makeQuery("/service/checkTalon", {dataRequest: {}, guidTalon : this.guidTalon})
            .then(result => {
              this.showInfo = true;

              if(result.allowed != undefined){
                this.allowed = result.allowed;
                
                if(this.allowed == 0){
                  this.classes = 'danger';
                  this.changeTS = false;
                  this.scanQR = true;
                }else if(this.allowed == 1){
                  this.classes = 'success';
                  this.changeTS = true;
                  this.scanQR = false;
                } else if(this.allowed == 2){
                  this.classes = 'warning';
                  this.changeTS = true;
                  this.scanQR = false;
                }

              }
              if(result.amount != undefined){
                this.amount = result.amount;
              }
              if(result.date != undefined){
                this.date = this.dtForm(result.date);
              }
              if(result.number != undefined){
                this.number = result.number;
              }

            })
            .catch(result => {this.showNotification('custom-error','Error',result); });

          },
          clearParams(){
            this.allowed = false;
            this.classes = 'secondary';
            this.amount = null;
            this.date = null;
            this.number = null;

            this.scanQR = true;
            this.changeTS = false;

            this.payment = false;
            this.askPayment = false;

            this.showInfo = false;
          },
          dtForm(dt){
            if(dt.indexOf('T') > -1){
              let d = new Date(dt);
              let year = d.getFullYear();
              let month = d.getMonth()+1;
              let day = d.getDate();
              let hours = d.getHours();
              let min = d.getMinutes();
              let sec = d.getSeconds();
              if (day<10) { day = '0' + day }
              if (month<10) { month = '0' + month }
              if (hours<10) { hours = '0' + hours }
              if (min<10) { min = '0' + min }
              if (sec < 10){ sec = '0' + sec; }
              
              return year + '.' + month + '.' + day + ' ' + hours + ':' + min + ':' + sec;
            } else {
              return dt;
            }
          },
          changeTalon(){

            if((this.allowed == 1) || ((this.allowed == 2) && (this.payment)) ){
              this.makeQuery("/service/setStatusTalon", {guidTalon : this.guidTalon })
              .then(result => {
                this.showNotification('custom-success','Успішно','Дані виїзду змінено', 25000);
                this.clearParams();
              })
              .catch(result => {this.showNotification('custom-error','Error',result); });
            }

            if((this.allowed == 2) && (!this.checkedPay)){
              this.showInfo = false;
              this.scanQR = false;
              this.changeTS = false;
              this.askPayment = true;
            }

            if(this.allowed == 0){
              this.clearParams();
            }
          }
        },
        computed: {},
        components: {},
        mounted () {},
        watch:{
        },
        created(){}
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/Parking.vue